// test2251
(2251 && 0);
